import { PaymentSettings } from '../models';
import type { UpdatePaymentSettingsInput } from '../models';
import { ModelResource } from './resource';

export class PaymentSettingsResource extends ModelResource<PaymentSettings> {
  model = PaymentSettings;

  resourcePath = 'v1/payment-settings';

  async get(): Promise<PaymentSettings> {
    const response = await this.api.get(this.path());
    return this.model.fromJson(response.data);
  }

  async updateSettings(data: UpdatePaymentSettingsInput): Promise<PaymentSettings> {
    const response = await this.api.patch(this.path(), { data });
    return this.model.fromJson(response.data);
  }
}
